<script>
import { defineComponent } from "vue";
import SelectWithSearch from "@/views/pages/Dilfoods/Common/SelectWithSearch.vue";
import axios from "axios";
import { VENDORS_PATH, ImagesPath } from "@/path";
import Swal from "sweetalert2";

export default defineComponent({
  props: ["selectedVendor"],
  components: { SelectWithSearch },
  data() {
    return {
      cdn: process.env.VUE_APP_AWS_CDN,
      baseUrl: process.env.VUE_APP_API_BACKEND_URL,
      form: {},
    };
  },
  watch: {
    selectedVendor(v) {
      this.form = v;
    },
  },
  mounted() {
    if (this.selectedVendor) {
      this.form = this.selectedVendor;
    }
  },
  methods: {
    async saveDocument(e, doc) {
      try {
        let formData = new FormData();
        formData.append("file", e.target.files[0]);
        formData.append("folder", "items");
        let res = await axios.post(
          this.baseUrl + ImagesPath.UPLOAD_IMAGE,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (res.data.status) {
          this.form.images[doc].img_url = res.data.data.file;
        }
      } catch (err) {
        console.log(err);
      }
    },
    async saveVendor() {
      this.form.country = "India";
      try {
        let res = await axios.post(this.baseUrl + VENDORS_PATH.SAVE, this.form);
        if (res.data.status) {
          Swal.fire("success", "", "success");
          this.$bvModal.hide("bv-add-vendor");
          this.$emit("update");
        }
      } catch (e) {
        console.log(e);
      }
    },
    async updateVendor() {
      try {
        let res = await axios.post(
          this.baseUrl + VENDORS_PATH.UPDATE,
          this.form
        );
        if (res.data.status) {
          Swal.fire("success", "", "success");
          this.$bvModal.hide("bv-add-vendor");
          this.$emit("update");
        }
      } catch (e) {
        console.log(e);
      }
    },
    async deleteDocument(v) {
      try {
        this.form.documents.splice(v, 1);
      } catch (e) {
        console.log(e);
      }
    },
  },
});
</script>

<template>
  <div class="card">
    <div class="card-body">
      <b-row>
        <b-col class="mt-3" sm="6">
          <label>Name</label>
          <b-form-input size="sm" v-model="form.name"></b-form-input>
        </b-col>
        <b-col class="mt-3" sm="6">
          <label>Email</label>
          <b-form-input
            size="sm"
            type="email"
            v-model="form.email"
          ></b-form-input>
        </b-col>
        <b-col class="mt-3" sm="6">
          <label>Phone</label>
          <b-form-input
            size="sm"
            type="number"
            v-model="form.mobile_number"
          ></b-form-input>
        </b-col>
        <b-col class="mt-3" sm="6">
          <label>GST</label>
          <b-form-input size="sm" v-model="form.gst"></b-form-input>
        </b-col>
        <b-col class="mt-3" sm="6">
          <label>City</label>
          <b-form-input size="sm" v-model="form.city"></b-form-input>
        </b-col>
        <b-col class="mt-3" sm="6">
          <label>State</label>
          <b-form-input size="sm" v-model="form.state"></b-form-input>
        </b-col>
        <b-col class="mt-3" sm="6">
          <label>Address</label>
          <b-input v-model="form.address" size="sm"></b-input>
        </b-col>
      </b-row>
    </div>
    <div class="card-footer">
      <b-button
        @click="form.id ? updateVendor() : saveVendor()"
        variant="primary"
        >Save</b-button
      >
    </div>
  </div>
</template>

<style></style>
